export const getUser = (state) => state.user;
export const getUserData = (state) => state.user?.userData;
export const getUserFirstName = (state) => getUserData(state)?.viewer?.givenName;
export const getUserLastName = (state) => getUserData(state)?.viewer?.familyName;
export const getUserEmail = (state) => getUserData(state)?.viewer?.email;
export const isSuperUser = (state) => getUserData(state)?.viewer?.isSuperUser;
export const isTOCSAccepted = (state) => getUserData(state)?.viewer?.tocAccepted;
export const isAuthenticating = (state) => state.user.authenticating;